import {isMobile} from '../utils';

const mobile = isMobile();

export const DEFAULT_COPY = 'Make.\nSomething.\nMove.'
export const DEFAULT_FONT_OPTIONS = {
    family: 'aktiv-grotesk-medium',
    fontWeight: '400',
    customFont: null,
    maxWidth: mobile && window ? window.innerWidth - 40 : 750, // px
    size: mobile ? 40 : 85, // px
    color: '#ffffff',
    lineHeight: mobile ? 60 : 113,  // px
    letterSpacing: 0,       // em
    underline: false,
}

export const DEFAULT_TRANSITION_OPTIONS = {
    bezierCurve: [0.0, 0.4, 0.4, 1.0],
    offset: 45,
    duration: 1275,
	opacity: true,
    opacityDelay: 0,
    direction: 'bottom',
	reveal: 'character',
	multilineOffsetDelay: 200,      // ms
    multilineMasking: true,
    perspective: false,
    perspectiveFOV: 1000,           // px
    perspectiveX: 0,                // deg 
    perspectiveY: 0,                // deg
	wordOffsetDelay: 200,           // ms
	characterOffsetDelay: 25,       // ms
	characterWordSpacing: 10,       // px  --  When breaking up words by character, the spaces (which we remove from the character list) between words need to have a manual width set.
}

export const DEFAULT_BACKGROUND_OPTIONS = {
    bgRandom: false,
    bgRandomTimestamp: `https://picsum.photos/1500/768?timestamp=${Date.now()}`, // Used to get new lorempicsum image
    bgOpacity: 100,
    showBgColor: false,
    bgColor: '#cccccc',
    customImage: null,
}   